import { Dispatch, SetStateAction } from 'react';

import { Field } from 'coreOld/components';
import { Icon } from 'coreOld/elements';
import { InputType, Size } from 'coreOld/enums';
import { partsService } from 'partsOld/services';

import { menuListStyle, optionStyle } from './searchFieldStyle';

interface IProps {
  goToParts: (search?: string) => void;
  onKeyDown: (event: KeyboardEvent, searchText: string) => void;
  setIsSearchFocus: Dispatch<SetStateAction<boolean>>;
}

const SearchFieldView = ({ goToParts, onKeyDown, setIsSearchFocus }: IProps) => {
  return (
    <Field
      type={InputType.ASYNC_SELECT}
      name="search"
      inputProps={{
        getOptions: partsService.getManyAutocomplete,
        getLabel: (opt) => [opt?.number, opt?.manufacturerName].join(' | '),
        requestPayload: {
          manufacturerIncluded: 1,
        },
        startIcon: <Icon name={Icon.SEARCH} />,
        onSearchClick: (searchText) => goToParts(searchText),
        onChange: (value) => goToParts(value),
        onKeyDown,
        isClearable: false,
        size: Size.MD,
        fontInherit: true,
        optionStyle: optionStyle,
        menuListStyle: menuListStyle,
        placeholder: '',
        onFocus: () => setIsSearchFocus(true),
        onBlur: () => setIsSearchFocus(false),
      }}
    />
  );
};

export default SearchFieldView;
